export const messages: {
  [key: string]: { firstMessage: string; fourCornerMessage: string };
} = {
  ['SELFIE']: {
    firstMessage: 'lbl.place_face_in_oval',
    fourCornerMessage: 'lbl.face_not_found'
  },
  ['DL_FRONT']: {
    firstMessage: 'lbl.doc_center_dark_background',
    fourCornerMessage: 'lbl.doc_center_dark_background'
  },
  ['PASSPORT']: {
    firstMessage: 'lbl.picture_page_dark_background',
    fourCornerMessage: 'lbl.picture_page_dark_background'
  },
  ['DOCUMENT']: {
    firstMessage: 'lbl.doc_center_dark_background',
    fourCornerMessage: 'lbl.doc_center_dark_background'
  }
};
